var productCardMarkup=`
<div class="row no-gutters">
 {{#products}}	
<div class="col">
  <div class="product_grid">
    <div class="pro_grid_top">
      <div class="pro_img">            
        <div class="pro_grid_img">    
          <a href="{{du}}">
            <img src="{{iu}}">          
          </a>    
        </div>
      </div>
    </div>
    <div class="pro_grid_btm">
      <div>
		<div class="pro_gridmeta">
        	<h5><a href="{{du}}">{{dt}}</a></h5>         
      	</div>
        <div class="pro_grid_price">  
          <span class="bp_regular">{{cu}}{{pr}}</span>        
        </div>               
        <div class="pro_grid_star">
          <div class="hc-widget">
            <div data-hc="product-rating" data-hc-id="{{empi}}"></div>
          </div>
        </div>
		<div>
           <button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}}swym-added{{/isInCart}}"data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}"class="swym-add-to-cart-btn swym-button swym-button-1 swym-is-button swym-is-button button">
              {{#isInCart}}Moved to cart{{/isInCart}}{{^isInCart}}Move to cart{{/isInCart}}
          </button>
		</div>
		<div>
          <button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">Remove</button>
	 	</div>
      </div>
    </div>
  </div>
</div>
 {{/products}}
</div>
`;
function getVariantInfo(variants) {
  try {
    let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
        variantinfo;
    if (variantKeys.length > 0) {
      variantinfo = variantKeys[0];
      if (variantinfo == "Default Title") {
        variantinfo = "";
      }
    } else {
      variantinfo = "";
    }
    return variantinfo;
  } catch (err) {
    return variants;
  }
}
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */
function swymRenderWishlist(swat) {
  // Get wishlist items
  swat.fetch(function(products) {
    //console.log(products)
    var wishlistContentsContainer = document.getElementById("wishlist-container");
    var formattedWishlistedProducts = products.map(function(p) {
      p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
      p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
      p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
      return p;
    });
    var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
      products: formattedWishlistedProducts
    });
    if(wishlistContentsContainer){
      wishlistContentsContainer.innerHTML = productCardsMarkup;
      attachClickListeners();
    } else{
      console.log("Container not found, Wishlist Page element not found");
    }

  });
}
function onAddToCartClick(e) {
  e.preventDefault();
  var productId = e.currentTarget.getAttribute("data-product-id");
  var variantId = e.currentTarget.getAttribute("data-variant-id");
  var du = e.target.getAttribute("data-product-url");
  e.target.innerHTML = "Adding..";
  window._swat.replayAddToCart({
    empi: productId,
    du: du
  }, variantId, function(c) {
    e.target.innerHTML = "Added to Cart";
    e.target.setAttribute("data-state-cart", "swym-added");
    console.log("Successfully added product to cart.");
  }, function(ef) {
    console.log(e,"soldout");
    //e.target.innerHTML = "Sold Out";
    e.target.innerHTML = "Sold Out";
  });
}

function attachClickListeners() {
  var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
  var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
  //   Add to cart Btns
  for (var i = 0; i < addToCartButtons.length; i++) {
    addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
  }
  //   Remove Buttons
  for (var k = 0; k < removeBtns.length; k++) {
    removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
  }
  console.log("Events attached!");
}
function onRemoveBtnClick(e) {
  e.preventDefault();
  var epi = +e.currentTarget.getAttribute("data-variant-id");
  var empi = +e.currentTarget.getAttribute("data-product-id");
  window._swat.fetch(function(products) {
    products.forEach(function(product) {
      if (epi && empi && product.epi == epi && product.empi == empi) {
        window._swat.removeFromWishList(product, function() {
          if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
          }
          window.SwymCallbacks.push(swymRenderWishlist);
        });
      }
    });
  })
}

$(document).ready(function(){
  $('.wishlist-searchbox input[type="text"]').keyup(function(){
    $('.wishlist-block .col.pro_colmn').hide();
    $('.wishlist-block .row').hide();
    $('.wishlist-block .row').each(function(){
      $(this).find('.col.pro_colmn').each(function(){
        var main_text = $(this).find('.pro_gridmeta a').text();
        main_text = main_text.toLowerCase().replace(/ /g,'-');
        var value = $('.faq-searchbox input[type="text"]').val();
        value = value.toLowerCase().replace(/ /g,'-');
        console.log('main_text',main_text,'value',value);
        if (value == '')
        {
          $('.wishlist-block .col.pro_colmn').show();
          $('.wishlist-block .row').show();
        }
        else {
          if(main_text.includes(value))
          {
            $(this).show();
            $(this).parent('.row').show();
//             $(this).closest('.col.pro_colmn').show();
          }
        }
      });
    });
  });
});